// @flow
import type {GraphQLTaggedNode} from 'react-relay'
import {graphql} from 'react-relay'
import classNames from 'classnames'

import type {Strategy} from 'components/proposals/types'
import Editor from './Editor'
import Summary from './Summary'
import createPartComponent from '../createPartComponent'
import fetchFieldsFromChange from './fetchFieldsFromChange'
import changePayload from './changePayload'
import type {Change, Role, State} from './types'

/* eslint class-methods-use-this: 0 */

const query = {
  subscriptionChange: graphql`
    fragment ElectRoleFillerSubscription_change on DescribeChangeable {
      ... on ElectRoleFillerChange {
        assignedUntil
        
        person {
          databaseId
          name
        }
        
        role {
          databaseId
          localizedName
        }
      }
    }
  `,
  change: graphql`
    fragment ElectRoleFiller_change on DescribeChangeable {
      id
      databaseId
      command
      type
      
      alerts {
        path
        message
        severity
      }
      
      ... on ElectRoleFillerChange {
        organization {
          autocompletePeople(first: 10000) {
            name
            databaseId
          }
        }
      }
      
      ...ElectRoleFillerSubscription_change @relay(mask: false)
    }
  `,
}

class ElectRoleFillerStrategy implements Strategy {
  static displayName: string = 'ElectRoleFiller'
  static fieldsFromChange: any = fetchFieldsFromChange
  static query: {[string]: GraphQLTaggedNode, ...} = query

  change: Change
  changeKey: string

  constructor(change: Change) {
    this.change = change
    this.changeKey = `Part-ElectRoleFiller-${change.databaseId || 'new'}`
  }

  get role(): ?Role {
    return this.change.role
  }

  get roleDatabaseId(): string {
    return this.role ? this.role.databaseId : ''
  }

  get partDescription(): string {
    return this.role ? this.role.localizedName : ''
  }

  get className(): string {
    return classNames(
      'refinery-elect-role-filler',
      `elect-role-filler-${this.roleDatabaseId}`,
    )
  }

  get partTitle(): string {
    return I18n.t('proposals.role_elect.elect_to_role2')
  }

  changePayload(state: State): Change {
    return changePayload(this.change, state)
  }
}

export {
  ElectRoleFillerStrategy,
}

export default (createPartComponent(ElectRoleFillerStrategy, Editor, Summary): any)
